export const MagicToolActions = {
    UPDATE_UNSAVED_MAGIC_ANNOTATIONS : "UPDATE_UNSAVED_MAGIC_ANNOTATIONS",
    UPDATE_UNSAVED_MAGIC_ANNOTATIONS_RAW : "UPDATE_UNSAVED_MAGIC_ANNOTATIONS_RAW",
    UPDATE_TOOL_START_POINT: "UPDATE_TOOL_START_POINT",
    RESET_MAGIC_TOOL_DATA: "RESET_MAGIC_TOOL_DATA",
    FETCHING_DATA: "FETCHING_DATA",
    UPDATE_CURRENT_LEVEL: "UPDATE_CURRENT_LEVEL",
    RELOAD: "RELOAD",
    UPDATE_CURR_POINT: "UPDATE_CURR_POINT",
}